import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateMemberRequest,
  CreateMemberResponse,
  FlagMemberAsPaidRequest,
  VerifyMemberStatusRequest
} from './external-registration.types';

import {
  requestCreateMember,
  requestFindActiveProgrammes,
  requestFlagMemberAsPaid,
  requestVerifyMemberStatus
} from './external-registration.actions';

export const useExternalRegistrationApi = () => {
  const dispatch = useDispatch();

  const findActiveProgrammes = useCallback(() => {
    dispatch(requestFindActiveProgrammes());
  }, [dispatch]);

  const createMember = useCallback(
    (requestData: CreateMemberRequest, onSuccess?: (data: CreateMemberResponse) => void) => {
      dispatch(requestCreateMember({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const flagMemberAsPaid = useCallback(
    (requestData: FlagMemberAsPaidRequest, onSuccess?: () => void) => {
      dispatch(requestFlagMemberAsPaid({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const verifyMemberStatus = useCallback(
    (requestData: VerifyMemberStatusRequest, onSuccess?: () => void) => {
      dispatch(requestVerifyMemberStatus({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { findActiveProgrammes, createMember, flagMemberAsPaid, verifyMemberStatus };
};
